import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from './lib/query';
import { router } from './router';
import './styles/global.css';

// A deploy replaces hashed chunk files, so a tab holding a pre-deploy
// index.html gets the SPA fallback (text/html) when it lazily imports a chunk
// that no longer exists. Reload once to pick up the new asset manifest;
// sessionStorage guards against a reload loop if the failure persists.
window.addEventListener('vite:preloadError', (event) => {
  const RELOAD_FLAG = 'chunk-reload-at';
  const last = Number(sessionStorage.getItem(RELOAD_FLAG) ?? 0);
  if (Date.now() - last < 30_000) return; // still failing after a reload — give up
  sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
